export const INVENTORY_DATA_UPLOAD = {
    FILES_INPUT: "files-input",
    UPLOADING_NTFN: "uploading-notification",
    PROCESSING_NTFN: "processing-notification",
    STATUS_TITLE: "status-title",
    SUMMARY: "summary",
    DOWNLOAD_RESULTS_BTN: "download-results-button",
    UPLOAD_ERROR_NTFN: "upload-error-notification",
    FILE_UPLOAD_NTFN: "file-upload-notification",
    COUNTDOWN_NTFN: "countdown-notification",
    TOTAL_FILES_TO_UPLOAD: "total-files-to-upload",
    SPECIFICATION: "specification",
    SPECIFICATION_TITLE: "specification-title",
    ADDITIONAL_SPECIFICATION: "additional-specification",
    ADDITIONAL_SPECIFICATION_TITLE: "additional-specification-title",
    FILES_ICON: "files-icon",
    FILES_CONTAINER: "files-container",
    START_NOW_BTN: "start-now-button",
    VALIDATION_ERROR_MAX_FILES: "validation-error-max-files",
    VALIDATION_ERROR_MAX_SIZE: "validation-error-max-size",
    VALIDATION_ERROR_WRONG_TYPE: "validation-error-wrong-type",
};
